export enum Permission {
  ADD_TO_CART,
  ADD_TO_WISHLIST,
  ADD_TO_QUOTE,
  SEARCH_ORDERS,
  SEARCH_QUOTES,
  PLACE_ORDER,
  PLACE_QUOTE,
  USER_MANAGEMENT,
  CHECKOUT,
  SHOW_INTERNAL_COMMENTS,
  PRICE,
  AVAILABILITY,
  BULK_UPLOAD,
  VIEW_CONTRACT,
  NO_PRICE_PRODUCTS, // This permission allows you to place orders with 0 price products, otherwise you can only quote then
  ANONYMOUS,
  GO_PUBLIC, // Anonymous with go public enabled
  SEE_SCALE_PRICE,
  SEE_ALL_SCALE_PRICE,
  ADD_VIEW_COMMENTS_DMA, // User may add and read (public) comments on cart and active quote. Internal comments don't check for this. Only for products of type DMA.
  ADD_VIEW_HEADER_LEVEL_COMMENTS,
  ORDER_CONTACT,
  ADD_VIEW_COMMENTS_PMA, // User may add and read (public) comments on cart and active quote. Internal comments don't check for this. Only for products of type PMA.
  SEE_LIST_PRICE,
  SEE_DISCOUNT, // See discount in pricing tables
  SEE_ABMONITOR, // See ab monitor page
  /**
   * @deprecated - Remove later
   */
  SEE_TRANSLATION_KEYS,
  SEE_ENDCUSTOMER_TABULAR_VIEW, //tabular home page
  REGISTERED_USER, // User has self registered
  LINEAR_IMPORT,
  LINEAR_PURCHASE, // May add LC product to cart/quote
  COMPLETE_DELIVERY, // See on Order Details/Checkout the Delivery Option block
  ALTERNATIVE_PRODUCTS, // See alternative products on PDP
  SEE_NOTIFICATIONS,
  CAN_SEE_SERVICE_CASES,
  CanOpenFCC,
}

const permissionsMap = {
  [Permission.ADD_TO_CART]: "ROLE_ADDTOCARTACTION",
  [Permission.ADD_TO_WISHLIST]: "ROLE_ADDTOWISHLISTACTION",
  [Permission.ADD_TO_QUOTE]: "ROLE_ADDTOQUOTEACTION",
  [Permission.SEARCH_ORDERS]: "ROLE_ORDERSEARCHACTION",
  [Permission.SEARCH_QUOTES]: "ROLE_QUOTESEARCHACTION",
  [Permission.PLACE_ORDER]: "ROLE_PLACEORDERACTION",
  [Permission.PLACE_QUOTE]: "ROLE_PLACEQUOTEACTION",
  [Permission.USER_MANAGEMENT]: "ROLE_B2BADMINGROUP",
  [Permission.CHECKOUT]: "ROLE_CHECKOUTACTION",
  [Permission.SHOW_INTERNAL_COMMENTS]: "ROLE_SHOWINTERNALCOMMENTSACTION",
  [Permission.PRICE]: "ROLE_PRICEACTION",
  [Permission.AVAILABILITY]: "ROLE_AVAILABILITYACTION",
  [Permission.BULK_UPLOAD]: "ROLE_BULKUPLOADACTION",
  [Permission.VIEW_CONTRACT]: "ROLE_VIEWCONTRACTACTION",
  [Permission.NO_PRICE_PRODUCTS]: "ROLE_NOPRICEPRODUCTACTION",
  [Permission.ANONYMOUS]: "ROLE_ANONYMOUS",
  [Permission.GO_PUBLIC]: "ROLE_PUBLIC",
  [Permission.SEE_SCALE_PRICE]: "ROLE_SEETWOSCALES",
  [Permission.SEE_ALL_SCALE_PRICE]: "ROLE_SEEALLSCALES",
  [Permission.ADD_VIEW_COMMENTS_DMA]: "ROLE_ADDCARTQUOTECOMMENT",
  [Permission.ADD_VIEW_HEADER_LEVEL_COMMENTS]: "ROLE_ADDCARTQUOTEHEADERCOMMENT",
  [Permission.ORDER_CONTACT]: "ROLE_ORDERCONTACT",
  [Permission.ADD_VIEW_COMMENTS_PMA]: "ROLE_ADDCARTQUOTECOMMENT-PMA",
  [Permission.SEE_LIST_PRICE]: "ROLE_SEELISTPRICE",
  [Permission.SEE_DISCOUNT]: "ROLE_SEEDISCOUNT",
  [Permission.SEE_ABMONITOR]: "ROLE_SEEABMONITORACTION",
  [Permission.SEE_TRANSLATION_KEYS]: "ROLE_SEETRANSLATIONKEYS",
  [Permission.SEE_ENDCUSTOMER_TABULAR_VIEW]: "ROLE_SELECTACCOUNTENDCUSTOMERACTION",
  [Permission.REGISTERED_USER]: "ROLE_REGISTEREDUSERGROUP",
  [Permission.LINEAR_IMPORT]: "ROLE_LC_IMPORT",
  [Permission.LINEAR_PURCHASE]: "ROLE_LC_ADDCARTQUOTE",
  [Permission.COMPLETE_DELIVERY]: "ROLE_COMPLETE_DELIVERY",
  [Permission.ALTERNATIVE_PRODUCTS]: "ROLE_SEEALTERNATIVEPRODUCTS",
  [Permission.SEE_NOTIFICATIONS]: "ROLE_NOTIFICATIONS",
  [Permission.CAN_SEE_SERVICE_CASES]: "ROLE_CAN_SEE_SERVICE_CASES",
  [Permission.CanOpenFCC]: "ROLE_SEEFCCACTION",
};

function getPermissionsObj() {
  return window.SCHA?.user?.roles ?? [];
}

export function userHasPermission(permission: Permission): boolean {
  const strPermission = permissionsMap[permission];
  return getPermissionsObj().indexOf(strPermission) !== -1;
}

export function userHasAnyPermission(...permissions: Permission[]): boolean {
  return permissions.some(userHasPermission);
}

export function userHasAllPermissions(...permissions: Permission[]): boolean {
  return permissions.every(userHasPermission);
}

export function userHasNoPermissions(): boolean {
  return getPermissionsObj().length === 0;
}
